import { useStyletron } from '@thanx/uikit/theme'
import Badge from 'components/Badge'
import { buildTranslate } from 'locales'
import React from 'react'
import { merchantTheme } from 'theme'

const t = buildTranslate('users.view.activity.points_expiration.status')

type Props = {
  status: 'expired' | 'scheduled' | 'reversed'
}

const StatusBadge: React.FC<Props> = ({ status }) => {
  const [css] = useStyletron()
  let color, backgroundColor

  switch (status) {
    case 'expired':
      color = merchantTheme.colors.grey70
      backgroundColor = merchantTheme.colors.grey20
      break
    case 'scheduled':
      color = merchantTheme.colors.eggYolk50
      backgroundColor = merchantTheme.colors.eggYolk10
      break
    case 'reversed':
      color = merchantTheme.colors.cayenne50
      backgroundColor = merchantTheme.colors.cayenne10
      break
    default:
      break
  }

  return (
    <Badge
      value={t(status)}
      className={css({
        backgroundColor,
        color,
      })}
    />
  )
}

export default StatusBadge
